import React, { useCallback } from "react";
import { debounce } from "lodash";
// import "../../../styles/time-sheet/time-sheet.css";
import "../../../styles/reports-subscription/timesheet.css";

const SearchFilter = ({ selectedSearch, setSelectedSearch }) => {
  const handleSearchChange = useCallback(
    debounce((value) => {
      setSelectedSearch(value);
    }, 300),
    []
  );

  return (
    <div
      className={`timesheet_dropdown_wrapper ${
        selectedSearch ? "has-selection" : ""
      }`}
    >
      <input
        type="search"
        defaultValue={selectedSearch}
        placeholder="Search..."
        onChange={(e) => handleSearchChange(e.target.value)}
        className={`commonWrapper ${selectedSearch ? "has-value" : ""}`}
      />
    </div>
  );
};

export default SearchFilter;
